/* eslint-disable no-console */

import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

import packageJson from '../../../../package.json';
import { authentication } from '../../authentication';
import { CORRELATION_ID } from '../../../constants/storage';

import { Log } from './interfaces';
import MessageAdapter from './messageAdapter';

class SentryAdapter extends MessageAdapter {
  constructor(tunnelUrl: string) {
    // We want to hide dsn and map it in the sentry-tunnel based on placeholder values
    const dummyDsn = 'http://PLACEHOLDER_PUBLIC_KEY@PLACEHOLDER_HOST/1'; // IMPORTANT!: THIS VALUE CAN'T BE CHANGED!

    Sentry.init({
      release: packageJson.version,
      dsn: dummyDsn,
      tunnel: `${tunnelUrl}/logger`,
      environment: window.location.hostname,
      beforeSend: event => {
        const correlationId = localStorage.getItem(CORRELATION_ID);
        event.tags = {
          ...event.tags,
          'X-Request-Correlation-Id-V2': correlationId
        };
        return event;
      },
      transportOptions: {
        dsn: dummyDsn
      },
      integrations: [new Integrations.BrowserTracing()]
    });
    super();
  }

  critical(message: string) {
    const correlationId = localStorage.getItem(CORRELATION_ID);

    console.error(message);
    console.trace();

    Sentry.captureException(new Error(message), { level: Severity.Critical });
    authentication.logout({ text: message, correlationId, severity: 'error' });
  }

  error(message: string) {
    Sentry.captureException(new Error(message), { level: Severity.Error });

    console.error(message);
  }

  warn(message: string) {
    console.warn(message);
  }

  info(message: string) {
    console.info(message);
  }

  showLogs(logs: Log[]) {
    console.table(logs);
  }
}

export default SentryAdapter;
